module.exports = __webpack_public_path__ + "static/img/upload_user.2001da6c.png";